import type { NextPage } from 'next';
import { Page as Component } from '~/containers/specifics/vendors/settings/accounts/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/vendors/settings/accounts';

const AccountSetting: NextPage = () => (
  <>
    <NskHead title="アカウント設定" />
    <Component />
  </>
);

export default AccountSetting;
